export default __webpack_public_path__ + "assets/radio.ef89f08f.svg";